export default __webpack_public_path__ + "static/media/104.d96e3d34.png";